import script from "./SelectedFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectedFilters.vue?vue&type=script&setup=true&lang=js"

import "./SelectedFilters.vue?vue&type=style&index=0&id=1d4b6e92&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4b6e92"]])

export default __exports__